module.exports = "/dist/be5cfaf67b2cc6ab503a90502ce1441e.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-500.eot
// module id = 14
// module chunks = 0